// extracted by mini-css-extract-plugin
module.exports = {"title":"ConsentItem_title__14IAJ","titleWithdrawn":"ConsentItem_titleWithdrawn__DDidc","date":"ConsentItem_date__2ol4G","container":"ConsentItem_container__1L_D9"};